export default __webpack_public_path__ + "static/media/DSC70006.28f8dc06.jpg";